module.exports = __webpack_public_path__ + "img/fuchsia_1340.b0390970.jpg";